
import { ExcelImportResult } from '@/model/event-flow/EventFlow';
import CustomModal from '@/components/modal/CustomModal.vue';
import { Component, Emit, Prop, Ref, Vue } from 'vue-property-decorator';
import { EXCEL_FILE_ACCEPT, isExcelFile } from '@/lib/excel-util';

@Component({
    components: {
        CustomModal,
    },
})
export default class EventFlowImportModal extends Vue {
    readonly modalId = 'event-flow-import-modal';

    @Prop({ default: false }) readonly importing!: boolean;

    @Prop({ default: null }) readonly importResult!: ExcelImportResult | null;
    @Prop({ default: false }) readonly downloadingTemplate!: boolean;

    readonly excelFileAccept = EXCEL_FILE_ACCEPT;

    selectedFile: File | null = null;

    @Ref() readonly fileInput!: HTMLInputElement;

    get isBusy(): boolean {
        return this.downloadingTemplate || this.importing;
    }

    get selectedFileName(): string {
        return this.selectedFile ? this.selectedFile.name : '';
    }

    get failedRowsMessage(): string {
        const failedRows = this.importResult?.failedRowNumbers ?? [];

        if (!failedRows.length) {
            return '';
        }

        const key = failedRows.length === 1 ? 'failed-row' : 'failed-rows';

        return this.$t(`event-flow.import.${key}`, {
            rows: failedRows.join(', '),
        }).toString();
    }

    openFilePicker(): void {
        this.fileInput.value = '';
        this.fileInput.click();
    }

    @Emit('download-template')
    downloadTemplate(): void {
        // Implemented by the Excel template task.
    }

    @Emit('file-selected')
    onFileSelected(event: Event): File | null {
        const input = event.target as HTMLInputElement;
        const file = input.files?.item(0) ?? null;

        if (file && !isExcelFile(file)) {
            this.selectedFile = null;
            input.value = '';
            this.$emit('invalid-file');
            return null;
        }

        this.selectedFile = file;
        return this.selectedFile;
    }

    @Emit('import')
    onImport(): File | null {
        const { selectedFile } = this;
        return selectedFile;
    }

    close(): void {
        this.$bvModal.hide(this.modalId);
    }

    @Emit('reset')
    reset(): void {
        this.selectedFile = null;
        if (this.fileInput) {
            this.fileInput.value = '';
        }
    }
}
